module.exports = __webpack_public_path__ + "img/display-single-knob-screenshot-phone-frame-with-shadow.b5530fde.png";